var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTexaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6827 24.5576C5.48076 19.3557 5.48076 10.9217 10.6827 5.71991",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7023 10.209C34.4312 5.47991 42.0985 5.47991 46.8275 10.209",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7441 40.5664H50.375C55.7252 40.5664 60.0625 36.2292 60.0625 30.8789C60.0625 25.5286 55.7252 21.1914 50.375 21.1914C50.2922 21.1914 50.2121 21.2017 50.1299 21.2039C50.2904 20.4174 50.375 19.6034 50.375 18.7695C50.375 12.0816 44.9534 6.66016 38.2656 6.66016C35.8442 6.66016 33.5941 7.37848 31.7019 8.60262C29.4165 4.55446 25.0818 1.81641 20.1016 1.81641C12.7449 1.81641 6.78125 7.78015 6.78125 15.1367C6.78125 16.8715 7.12298 18.5238 7.72639 20.0438C4.28357 21.8755 1.9375 25.4962 1.9375 29.668C1.9375 35.6869 6.81685 40.5664 12.8359 40.5664H14.2558",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0547 37.1758L24.9453 49.2852",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9453 37.1758L37.0547 49.2852",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9531 43.2305C47.9531 52.5934 40.363 60.1836 31 60.1836C21.637 60.1836 14.0469 52.5934 14.0469 43.2305C14.0469 33.8675 21.637 26.2773 31 26.2773C40.363 26.2773 47.9531 33.8675 47.9531 43.2305Z",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexaIcon);
export default __webpack_public_path__ + "static/media/texaIcon.1ea63383b10ad93e5a7b29bde6a10408.svg";
export { ForwardRef as ReactComponent };